import Breadcrumb from '@/components/UI/breadcrumb/Breadcrumb';
import styles from './SearchBreadcrumb.module.scss';
import { FC } from 'react';
import { SearchStateProps } from '@/redux/store/reducer/searchReducer';
import useSearchParams from '@/components/search/hooks/useSearchParams';
import { getFilteredH1, mainQueryLength } from '@/components/search/reusable/utils/Utils';
import usePlaceName from '@/components/search/hooks/usePlaceName';
import { suggestionsVillages } from '@/components/houses/productMeta/ProductMeta';
import { getEnvs } from '@/helpers/getEnvs';
interface SearchBreadcrumbProps {
  region_data: SearchStateProps['region_data'];
}
interface itemType {
  title: string;
  href?: string;
}
const domains = {
  green: 'https://www.shab.ir',
  white: 'https://www.shab.travel',
  blue: 'https://www.shab.rentals',
  purple: 'https://www.shabtravel.com'
};
const envColor = getEnvs()?.APP_ENVIRONMENT;
const SearchBreadcrumb: FC<SearchBreadcrumbProps> = ({
  region_data
}) => {
  const {
    params,
    queries
  } = useSearchParams();
  const placeName = usePlaceName(queries);
  if (params?.url === '/search') return <></>;
  const origin = domains[envColor as keyof typeof domains] || 'http://www.shab.ir';
  const items: itemType[] = [{
    title: 'اجاره ویلا',
    href: origin
  }];
  const nearCity = Array.isArray(queries.near_cities) ? queries.near_cities[0] : queries.near_cities;
  const phrase = (params.phrase || queries.phrase) as string | undefined;
  if (nearCity) {
    items.push({
      title: `اطراف ${nearCity}`,
      href: `${origin}/search?near_cities=${nearCity}`
    });
  } else if (phrase) {
    items.push({
      title: phrase,
      href: `${origin}/search?phrase=${phrase}`
    });
  } else {
    if (region_data?.province) {
      items.push({
        title: region_data?.province,
        href: `${origin}/search/province/${region_data?.province}`
      });
    }
    if (region_data?.city) {
      items.push({
        title: region_data?.city,
        href: `${origin}/search/city/${region_data?.city}`
      });
    }
    if (region_data?.village && suggestionsVillages.some(item => region_data?.village?.trim() === item)) {
      items.push({
        title: region_data?.village,
        href: `${origin}/search/village/${region_data?.village}`
      });
    }
  }
  if (mainQueryLength(queries) === 1) {
    const {
      city,
      province,
      village
    } = params;
    const text = getFilteredH1({
      queries,
      city,
      province,
      data: {
        region_data
      },
      placeName,
      village
    });
    items.push({
      title: text,
      href: `${origin}${params.url}`
    });
  }
  return <Breadcrumb data={items} className={`${styles['search-breadcrumb']}`} data-sentry-element="Breadcrumb" data-sentry-component="SearchBreadcrumb" data-sentry-source-file="SearchBreadcrumb.tsx" />;
};
export default SearchBreadcrumb;